import { CommonStore } from '../common-store';

const storeModule = new CommonStore(
  'camp/directions',
  { name: 'camp.directions' }
);

export default {
  namespaced: storeModule.namespaced,
  state: storeModule.state,
  getters: storeModule.getters,
  actions: storeModule.actions,
  mutations: storeModule.mutations
};
